<div class="ft-form">
  <div class="ft-form-row container mt-2">
    @for (card of cards(); track card.id) {
      <div class="report-card" (click)="onCardClick(card.id)" (keydown.enter)="onCardClick(card.id)" tabindex="0" style="cursor:pointer">
        <label class="report-card__crop-img-container">
          <input type="radio" name="report" [value]="card.id" class="report-card__radio" />
          <div class="report-card__select"></div>
          <img class="report-card__img" [src]="card.image" [alt]="card.title" loading="lazy"
               onerror="this.src='assets/images/fanchart.svg'" />
        </label>
        <p class="report-card__name">{{ card.title }}</p>
        <p class="report-card__description">{{ card.desc }}</p>
      </div>
    }
  </div>
  <div class="footer">
    <button class="ft-btn ft-btn-active-not-selected" (click)="cancel()">{{ "lbl_cancel" | translate }}</button>
  </div>
</div>